import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import CustomCard from '../../components/CustomCard';

const COLORS = ['#4f46e5', '#facc15', '#f87171'];

const GuestsByAgeChart = ({ data = [] }) => {
  if (!data.length) return null;

  return (
    <CustomCard shadow={false} title="Goście według wieku" width={6}>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            innerRadius={70}
            outerRadius={100}
            paddingAngle={4}
            dataKey="value"
            nameKey="name"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => [`${value}`, 'Liczba gości']}
            labelFormatter={() => 'Liczba gości'}
          />
          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </CustomCard>
  );
};

export default GuestsByAgeChart;
